<template>
  <div id="credential">
    <div v-if="checking"></div>
    <div class="notFound" v-else-if="!allowed">
      <h4 class="text-dark font-weight-bolder">Page not found!</h4>
    </div>
    <div v-else>
      <b-row>
        <b-col md="12">
          <LoginPage />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import LoginPage from "./LoginPage.vue";
import router from "../router";
import { getCurrentBaseSlug, isLoginSlugAllowed } from "../utils/institutionUrl";

export default {
  data() {
    return {
      checking: true,
      allowed: true,
    };
  },
  async created() {
    const slug = getCurrentBaseSlug(router);
    this.allowed = await isLoginSlugAllowed(slug);
    this.checking = false;
  },
  components: {
    LoginPage,
  },
};
</script>

<style >

#credential {
  color: #222;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

#credential .notFound {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
